<div class="filter-search-input form-group" [ngClass]="classes">
  @if (label) {
  <label [for]="name" class="filter-search-input-label">
    {{ label | translate }}
  </label>
  }

  <div class="filter-search-input-control">
    <input
      [id]="name"
      type="text"
      class="form-control filter-search-input-field {{ inputClass }}"
      [value]="value"
      [placeholder]="placeholder | translate"
      [disabled]="isDisabled"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown.enter)="onSearch($event)"
    />
    @if (value && !isDisabled) {
    <button
      type="button"
      class="filter-search-input-clear-button"
      aria-label="ล้างค่า"
      (click)="onClear($event)"
    >
      <span aria-hidden="true">×</span>
    </button>
    }
    <button
      type="button"
      class="filter-search-input-button"
      [attr.aria-label]="ariaLabel | translate"
      [disabled]="isDisabled"
      (click)="onSearch($event)"
    >
      <app-keenicon
        name="magnifier"
        class="filter-search-input-icon"
      ></app-keenicon>
    </button>
  </div>
</div>
